module.exports = __webpack_public_path__ + "static/media/winking-face-svgrepo-com.d5e6b84a.svg";